import {
  type PersonGeneral,
  personGeneralSchema,
  personMinimalGeneralFieldSchema,
} from '@quromedical/models';
import { CrudForm } from 'components/form';
import { minimalPersonGeneralFields, personGeneralFields } from 'core/forms';
import type { FormikErrors } from 'formik';
import type React from 'react';
import { useCallback } from 'react';
import { strings } from 'strings';

interface PersonGeneralFormCardProps {
  onValidChange: (data?: PersonGeneral) => void;
  showErrors: boolean;
  minimalData?: boolean;
}

export const PersonGeneralFormCard: React.FC<PersonGeneralFormCardProps> = ({
  onValidChange,
  showErrors,
  minimalData = false,
}) => {
  const onChange = useCallback(
    (
      data: Partial<PersonGeneral>,
      _: FormikErrors<PersonGeneral>,
      hasErrors: boolean,
    ) => {
      if (hasErrors) {
        onValidChange(undefined);
      } else {
        const result = data as PersonGeneral; // casting since data is validated

        onValidChange(result);
      }
    },
    [onValidChange],
  );

  const fields = minimalData ? minimalPersonGeneralFields : personGeneralFields;
  const schema = minimalData
    ? personMinimalGeneralFieldSchema
    : personGeneralSchema;

  return (
    <CrudForm
      title={strings.FormLabelPersonDetails}
      fields={fields}
      showSubmitButton={false}
      initialValues={{}}
      validationSchema={schema}
      onChange={onChange}
      showErrors={showErrors}
      validateOnMount
      hasCard={false}
    />
  );
};
